import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DivineServiceTypeApiService } from '@core/api/services/divine-service-type-api.service';
import {
  DivineServiceTypeDto,
  CreateDivineServiceTypeDto,
  UpdateDivineServiceTypeDto,
  UpdateDivineServiceTypeSortOrderDto,
} from '@core/api/generated/api-client';

export { DivineServiceTypeDto, CreateDivineServiceTypeDto, UpdateDivineServiceTypeDto };

@Injectable({ providedIn: 'root' })
export class DivineServiceTypeManagementService {
  constructor(private readonly api: DivineServiceTypeApiService) {}

  getAll(): Observable<DivineServiceTypeDto[]> {
    return this.api.getAll();
  }

  getById(id: number): Observable<DivineServiceTypeDto> {
    return this.api.getById(id);
  }

  create(dto: CreateDivineServiceTypeDto): Observable<DivineServiceTypeDto> {
    return this.api.create(dto);
  }

  update(id: number, dto: UpdateDivineServiceTypeDto): Observable<void> {
    return this.api.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }

  updateSortOrder(ids: number[]): Observable<void> {
    return this.api.updateSortOrder(UpdateDivineServiceTypeSortOrderDto.fromJS({ ids }));
  }
}
